// these extensions need to be supported by assembly ai for audio transcription
export const AUDIO_FILE_EXTENSIONS = ['mp3', 'mp4', 'm4a', 'wav', 'flac', 'ogg', 'webm'] as const;

// these extensions need to match those supported by Google Document AI
export const DOCUMENT_FILE_EXTENSIONS = ['pdf', 'docx', 'docx', 'pptx'] as const;
export const IMAGE_FILE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'tif', 'webp'] as const;

// these ones are processed by external libraries, so we can expand as needed
export const SPREADSHEET_FILE_EXTENSIONS = ['xls', 'xlsx', 'csv'] as const;
